import { Carousel } from 'antd';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { HomeOutlined } from "@ant-design/icons";

import PalestineMapSVG from '../assets/PalestineMapSVG';
import DEPARTMENTS_STATES from '../constants/departments-states';
import getTranslatedText from '../helpers/getTranslatedText';
import Translations from '../translations';

const constantColors = [
  '#FF5403',
  '#8B9A46',
  '#EEEEEE',
  '#9B0000',
  '#FABB51',
  '#79018C',
];

const PalestineDepartments = () => {
  const [selectedDepartmentIndex, setSelectedDepartmentIndex] = useState(0);

  const selectedDepartment =
    Object.keys(DEPARTMENTS_STATES)[selectedDepartmentIndex];
  const selectedDepartmentStates = DEPARTMENTS_STATES[selectedDepartment];

  const { lang } = useParams();

  const formatSelectedDepartmentStates = () => {
    return selectedDepartmentStates.map((id, index) => ({
      id,
      color: constantColors[index],
    }));
  };

  return (
    <div>
      <center>
        <PalestineMapSVG selectedIDs={[...formatSelectedDepartmentStates()]} />
      </center>
      <Carousel
        style={{ display: 'contents' }}
        beforeChange={(_, to) => setSelectedDepartmentIndex(to)}
      >
        {Object.keys(DEPARTMENTS_STATES).map(department => (
          <div key={department}>
            <h1 className="title">
              {getTranslatedText(Translations, department, lang)}
            </h1>
            <div id="statesContainer">
              {DEPARTMENTS_STATES[department].map((state, index) => (
                <h4 style={{ color: constantColors[index] }}>
                  {getTranslatedText(Translations, state, lang)}
                </h4>
              ))}
            </div>
          </div>
        ))}
      </Carousel>
      <Link
        to="/:"
        title="Home"
        id='home-btn'
      >
        <HomeOutlined style={{ fontSize: "25px", color: "white" }} />
      </Link>
    </div>
  );
};
export default PalestineDepartments;
